<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-total-points">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4 pointsContiner">
            <h5>Total Points</h5>
              <div class="top-filter-container">

                <!-- LEFT BLOCK: DATE RANGE -->
                <div class="filter-block">
                  <div class="filter-group">
                    <label>Start Date</label>
                    <input type="date" v-model="startDate" class="form-control small-date" />
                  </div>

                  <div class="filter-group">
                    <label>End Date</label>
                    <input type="date" v-model="endDate" class="form-control small-date" />
                  </div>
                </div>

                <!-- RIGHT BLOCK: SEARCH + CLIENT -->
                <div class="filter-block">

                  <div class="filter-group">
                    <label>Search Users ( By: firstname, lastname & username )</label>
                    <div class="input-group">
                      <input type="text" v-model="searchTerm" class="form-control" placeholder="Search users..." />
                      <button class="btn btn-primary" @click="search">Search</button>
                    </div>
                  </div>

                  <div class="filter-group">
                    <label>Select Client</label>
                    <div class="input-group">
                      <b-form-select
                        class="form-control"
                        v-model="SelectCompany"
                        :options="SelectCompanyOptions">
                      </b-form-select>
                      <button class="btn btn-primary" @click="seachClient">Select</button>
                    </div>
                  </div>

                </div>

              </div>

              <!-- EXPORT BUTTON -->
              <div class="export-section">
                <button class="btn btn-success export-btn" @click="showExportModal = true">
                  Export Report
                </button>
              </div>

              <!-- EXPORT MODAL -->
              <b-modal
                v-model="showExportModal"
                title="Export User Points Report"
                centered
                size="lg"
                hide-footer
                class="export-modal"
              >
                <div class="modal-body-content">

                  <p class="modal-info">
                    <strong>You will receive a report for:</strong>
                  </p>

                  <div class="summary-box">
                    <p><strong>Date Range: </strong> {{ startDate }} → {{ endDate }}</p>
                    <p><strong>Client: </strong> {{ selectedClientName }}</p>
                    <p><strong>Search Term: </strong> {{ searchTerm || "None" }}</p>
                  </div>

                  <label>Email Address</label>
                  <input
                    type="email"
                    v-model="exportEmail"
                    class="form-control"
                    placeholder="Enter email to receive report"
                  />

                  <p v-if="exportEmail && !isEmailValid" class="email-error">
                    ⚠️ Please enter a valid email address.
                  </p>

                  <div class="modal-btn-row">
                    <button class="btn btn-secondary" @click="showExportModal = false">
                      Cancel
                    </button>

                    <button class="btn btn-primary" @click="sendExportReport">
                      Generate Report
                    </button>
                  </div>

                </div>
              </b-modal>

              <a-table
                :columns="ClientListFields"
                :data-source="data"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
                bordered
                :row-key="(record) => record.id"
              >
              <span slot="name" slot-scope="text, record">
                {{ `${record.firstName} ${record.lastName}` }}
              </span>
              <span slot="points" slot-scope="text, record">
                <span v-if="record.points < 0">{{
                  parseInt(record.points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }}</span>
                <span v-else-if="record.points >= 0">{{
                  parseInt(record.points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }}</span>
              </span>
              <span slot="redeemed_points" slot-scope="text, record">
                <span v-if="record.redeemed_points < 0">{{
                  parseInt(record.redeemed_points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }}</span>
                <span v-else-if="record.redeemed_points >= 0">{{
                  parseInt(record.redeemed_points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }}</span>
              </span>
              <span slot="sales_tax_points" slot-scope="text, record">
                <span v-if="record.sales_tax_points < 0">{{
                  parseInt(record.sales_tax_points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }}</span>
                <span v-else-if="record.sales_tax_points >= 0">{{
                  parseInt(record.sales_tax_points)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }}</span>
              </span>
              <!-- Available Points TITLE -->
              <span slot="pointsTitle">
                <a-tooltip placement="top">
                  <template slot="title">Points available to user right now</template>
                  <span>Available Points ⓘ</span>
                </a-tooltip>
              </span>

              <!-- Redeemed Points TITLE -->
              <span slot="redeemedTitle">
                <a-tooltip placement="top">
                  <template slot="title">Points deducted for orders</template>
                  <span>Redeemed Points ⓘ</span>
                </a-tooltip>
              </span>

              <!-- Sales Tax Points TITLE -->
              <span slot="salesTaxTitle">
                <a-tooltip placement="top">
                  <template slot="title">Points deducted for sales tax associated with orders</template>
                  <span>Sales Tax Points ⓘ</span>
                </a-tooltip>
              </span>

            </a-table>

            <!-- Bottom Area with Pagination Controls -->
          <div class="bottom-controls">

            <div class="show-users">
              <label class="mr-2">Show</label>
              <select class="form-control" v-model="pageSize">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <label class="ml-2">users</label>
            </div>

            <!-- pagination is already handled internally by A-table -->

          </div>

            <hr />
            <p class="total-points">
              Total Points:
              {{
                totalPoints
                  ? parseInt(totalPoints)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                  : '0.00'
              }}
            </p>
            {{ (activeMenuItem, activeMenu) }}
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';

export default {
  name: 'TotalPoints',

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  data() {
    return {
      data: [],
      totalPoints: 0,
      sortField: '',
      sortOrder: '',
      searchTerm: '',
      startDate: "",
      endDate: "",
      showExportModal: false,
      exportEmail: "",
      pagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: false,   // you already control pageSize manually
        showQuickJumper: true,    // enables direct jump to page
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
      },
      loading: false,
      sortBy: 'id',
      sortDesc: false,
      SelectCompany: null,
      pageSize: 5,
      SelectCompanyOptions: [],
      ClientListFields: [
        {
          title: 'User Id',
          key: 'id',
          dataIndex: 'id',
          sorter: true,
        },
        {
          title: 'Username',
          key: 'userName',
          dataIndex: 'userName',
          sorter: true,
        },
        {
          title: 'Name',
          key: 'name',
          dataIndex: 'firstname',
          scopedSlots: { customRender: 'name' },
          sorter: true,
        },
        {
          title: 'Code',
          key: 'code',
          dataIndex: 'code',
          sorter: true,
        },
        // AVAILABLE POINTS
        {
          key: 'points',
          dataIndex: 'points',
          scopedSlots: { customRender: 'points', title: 'pointsTitle' },
          sorter: true,
          align: 'right',
        },

        // REDEEMED POINTS
        {
          key: 'redeemed_points',
          dataIndex: 'redeemed_points',
          scopedSlots: { customRender: 'redeemed_points', title: 'redeemedTitle' },
          sorter: true,
          align: 'right',
        },

        // SALES TAX POINTS
        {
          key: 'sales_tax_points',
          dataIndex: 'sales_tax_points',
          scopedSlots: { customRender: 'sales_tax_points', title: 'salesTaxTitle' },
          sorter: true,
          align: 'right',
        },
      ],
    };
  },
  mounted() {
    this.getCompaniesData();

    // Initialize tooltips
    if (window.$) {
      window.$('[data-toggle="tooltip"]').tooltip();
    }
  },
  computed: {
    selectedClientName() {
      const item = this.SelectCompanyOptions.find(c => c.value === this.SelectCompany);
      return item ? item.text : "Not Selected";
    },
    isEmailValid() {
      if (!this.exportEmail) return true; // Don't show error before typing
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.exportEmail);
    }
  },
  methods: {
      sendExportReport() {
      if (!this.exportEmail) {
        alert("Please enter email address.");
        return;
      }

      if (!this.startDate || !this.endDate) {
        alert("Please select date range before exporting.");
        return;
      }

      this.$store.dispatch("adminPointPrograms/newGetTotalPoints", {
        current: this.pagination.current,
        pageSize: this.pageSize,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        clientId: this.SelectCompany,
        searchTerm: this.searchTerm,
        startDate: this.startDate,
        endDate: this.endDate,
        email: this.exportEmail, // extra param!
      })
      .then(({ data }) => {
        if (data.success == false) {
          alert(data.error)
        } else {
          alert("Report generation started. You'll receive an email shortly.");
          this.showExportModal = false;
        }
      })
      .catch(err => {
        const backendError =
          err?.response?.data?.error ||
          err?.message ||
          "Failed to generate report";
        alert(backendError);
      });
    },
    search() {
      if (!this.startDate || !this.endDate) {
        alert("Please select Start Date and End Date before searching.");
        return;
      }
      this.pagination.current = 1;
      this.getPointsData({
        pageSize: this.pageSize,
        current: 1,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      });
    },
    handleTableChange(pagination, filters, sorter) {
      if (!this.startDate || !this.endDate) {
        alert("Select a date range before changing page.");
        return;
      }
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
      };

      this.sortField = sorter.field ?? '';
      this.sortOrder =
        sorter.order === 'ascend'
          ? 'ASC'
          : sorter.order === 'descend'
          ? 'DESC'
          : '';

      this.getPointsData({
        pageSize: pagination.pageSize,
        current: pagination.current,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      });
    },
    goToPage(page) {
      const pager = { ...this.pagination };
      pager.current = page;
      this.pagination = pager;
      this.getPointsData({
        pageSize: this.pagination.pageSize,
        current: page,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      });
    },
    getPointsData(params) {
      if (!this.startDate || !this.endDate) {
        alert("Please select both Start Date and End Date before fetching data.");
        this.loading = false;
        return; // STOP HERE ❌
      }
      this.loading = true;
      this.$store
        .dispatch('adminPointPrograms/newGetTotalPoints', {
          ...params,
          clientId: this.SelectCompany,
          searchTerm: this.searchTerm,
          startDate: this.startDate,
          endDate: this.endDate,
          email: ""
        })
        .then(({ data }) => {
          console.log(data)
          const pagination = { ...this.pagination };
          pagination.total = data.totalRecords;
          pagination.pageSize = data.pageSize;
          this.loading = false;
          this.data = data.Result;
          this.pagination = pagination;
          this.totalPoints = data.totalPoints;
          console.log(data.success)
          if (data.success == false) {
            console.log(")))))))))))))))))))))))))")
            alert(data.error)
          }
        }).catch((err) => {
          this.loading = false;
          // Extract backend error message safely
          const backendError =
            err?.response?.data?.error ||
            err?.data?.error ||
            err?.message ||
            "Something went wrong while fetching data.";

          alert(backendError);
        });
    },
    getCompaniesData() {
      this.$store.dispatch(`adminPointPrograms/getAuthorizedClients`).then((data) => {
        this.SelectCompanyOptions = data.map(({ clientId, clientName }) => {
          return { value: clientId, text: clientName };
        });
        this.SelectCompany = this.SelectCompanyOptions[0].value;
      });
    },
    seachClient() {
      if (!this.startDate || !this.endDate) {
        alert("Select date range before choosing client.");
        return;
      }
      const pagination = { ...this.pagination };
      pagination.current = 1;
      this.pagination = pagination;

      this.getPointsData({
        pageSize: this.pageSize,
        current: 1,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      });
    },
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'usersTotalPoints',
        activeMenu: this.activeMenu ? this.activeMenu : 'users',
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
  watch: {
    pageSize() {
      if (!this.startDate || !this.endDate) {
        alert("Please select both Start Date and End Date before changing entries.");
        return; // STOP here
      }
      this.pagination.current = 1;
      this.pagination.pageSize = this.pageSize;
      console.log(this.pageSize);
      this.getPointsData({
        pageSize: this.pageSize,
        current: 1,
        sortField: '',
        sortOrder: '',
      });
    },
  },
};
</script>

<style>

/* --------------------------------------------------
   TOP FILTER SECTION
-------------------------------------------------- */
.top-filter-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  background: #ffffff !important;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap; /* Stacks on zoom */
}

/* Two main blocks */
.filter-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 280px;
}

/* Form groups */
.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-group label {
  font-size: 13px;
  font-weight: 600;
}

.small-date {
  width: 200px !important;
  min-width: 200px !important;
}

/* Uniform inputs */
.filter-group input,
.filter-group select,
.input-group input {
  min-height: 38px;
  border-radius: 6px;
}

/* Input groups */
.input-group {
  display: flex;
  gap: 8px;
}

.input-group .btn {
  white-space: nowrap;
}

/* Responsive filter behavior */
@media (max-width: 1100px) {
  .top-filter-container {
    flex-direction: column;
  }
  .filter-block {
    width: 100%;
  }
  .small-date {
    width: 100% !important;
  }
  .input-group {
    flex-direction: column;
  }
  .input-group .btn {
    width: 100%;
  }
}

/* --------------------------------------------------
   EXPORT BUTTON
-------------------------------------------------- */
.export-section {
  margin: 15px 0;
}

.export-btn {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
  padding: 8px 18px;
  font-weight: 600;
}

/* --------------------------------------------------
   EXPORT MODAL STYLING
-------------------------------------------------- */
.export-modal .modal-dialog {
  max-width: 650px;
}

.modal-body-content {
  padding: 10px 20px;
}

.summary-box {
  background: #f0f6ff;
  padding: 14px 16px;
  border-radius: 8px;
  margin-bottom: 22px;
  font-size: 14px;
  line-height: 1.5;
}

.modal-btn-row {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.export-modal input {
  height: 40px;
  margin-top: 6px;
}

/* --------------------------------------------------
   BOTTOM CONTROLS (Show Users + Pagination)
-------------------------------------------------- */
.bottom-controls {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 10px;
}

.show-users {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.show-users select {
  width: 80px !important;
  min-width: 80px !important;
}

/* Responsive bottom controls */
@media (max-width: 768px) {
  .bottom-controls {
    flex-direction: column;
    gap: 14px;
  }
}

/* --------------------------------------------------
   MODERN PAGINATION REDESIGN (Beautiful & Uniform)
-------------------------------------------------- */

/* Center pagination and remove weird spacing */
.ant-pagination {
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  gap: 6px !important;
}

/* Default pagination button */
.ant-pagination-item {
  background: #ffffff !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 6px !important;
  height: 34px !important;
  min-width: 34px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 14px !important;
  transition: all 0.2s ease-in-out !important;
}

/* Hover */
.ant-pagination-item:hover {
  border-color: #1890ff !important;
  color: #1890ff !important;
}

/* Active page */
.ant-pagination-item-active {
  background: #1890ff !important;
  border-color: #1890ff !important;
}

.ant-pagination-item-active a {
  color: white !important;
  font-weight: 600 !important;
}

/* Arrows */
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  height: 34px !important;
  width: 34px !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: 0.2s ease-in-out !important;
}

/* Arrow hover */
.ant-pagination-prev .ant-pagination-item-link:hover,
.ant-pagination-next .ant-pagination-item-link:hover {
  border-color: #1890ff !important;
  color: #1890ff !important;
}

.ant-pagination-item-link svg {
  font-size: 16px !important;
}

/* Remove gray highlight for disabled arrows */
.ant-pagination-disabled .ant-pagination-item-link {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
}

.email-error {
  color: #d9534f;
  font-size: 13px;
  margin-top: 4px;
}


</style>